import { Modal } from '@mantine/core';
import { Status } from '../styles';
import { useContext } from 'react';
import { AvicContext } from './context';

const List = ({ logs, type }) =>
  logs.map((log) => (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <b>Distrubution Channel:</b> {log.channel}&nbsp;
        <Status status={type === 'success' ? 'Completed' : 'Failed'} />
      </div>

      <div>
        <b>Message:</b> {log[type === 'success' ? 'message' : 'error']}
      </div>
    </div>
  ));

export const Summary = ({ open, setOpen, details: { failedRows, successRows }, reset }) => {
  return (
    <Modal
      opened={open}
      onClose={() => {
        reset();
        setOpen(false);
      }}
      size={'50%'}
      title={`Summary`}
    >
      <List logs={successRows} type={'success'} />
      <List logs={failedRows} type={'fail'} />
    </Modal>
  );
};
